<template>
  <el-dialog
    :visible.sync="dialogVisible"
    title="个人资料"
    width="800px"
    :before-close="handleClose"
    class="profile-dialog"
  >
    <div class="profile-container" v-loading="loading">
      <!-- 用户头像区域 -->
      <div class="avatar-section">
        <div class="avatar-container">
          <el-upload
            class="avatar-uploader"
            :action="uploadAction"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :headers="uploadHeaders"
          >
            <img v-if="profile.avatar" :src="profile.avatar" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div class="avatar-info">
            <h3>{{ profile.username }}</h3>
            <p>{{ profile.email }}</p>
          </div>
        </div>
      </div>

      <!-- 表单区域 -->
      <el-form
        :model="formData"
        :rules="rules"
        ref="profileForm"
        label-width="120px"
        class="profile-form"
      >
        <!-- 修改密码区域 -->
        <div class="form-section">
          <h4 class="section-title">
            <i class="el-icon-lock"></i>
            修改密码
          </h4>
          <el-form-item label="原密码" prop="oldPassword">
            <el-input
              v-model="formData.oldPassword"
              type="password"
              placeholder="请输入原密码"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newPassword">
            <el-input
              v-model="formData.newPassword"
              type="password"
              placeholder="请输入新密码"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="confirmPassword">
            <el-input
              v-model="formData.confirmPassword"
              type="password"
              placeholder="请再次输入新密码"
              show-password
            ></el-input>
          </el-form-item>
        </div>

        <!-- 私人信息区域 -->
        <div class="form-section">
          <h4 class="section-title">
            <i class="el-icon-user"></i>
            私人信息
          </h4>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="真实姓名" prop="real_name">
                <el-input v-model="formData.real_name" placeholder="请输入真实姓名"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="性别" prop="gender">
                <el-select v-model="formData.gender" placeholder="请选择性别">
                  <el-option label="保密" :value="0"></el-option>
                  <el-option label="男" :value="1"></el-option>
                  <el-option label="女" :value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="年龄" prop="age">
                <el-input-number
                  v-model="formData.age"
                  :min="1"
                  :max="120"
                  placeholder="请输入年龄"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="生日" prop="birthday">
                <el-date-picker
                  v-model="formData.birthday"
                  type="date"
                  placeholder="请选择生日"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="格言" prop="bio">
            <el-input
              v-model="formData.bio"
              type="textarea"
              :rows="2"
              placeholder="请输入个人格言"
            ></el-input>
          </el-form-item>
        </div>

        <!-- 联系方式区域 -->
        <div class="form-section">
          <h4 class="section-title">
            <i class="el-icon-phone"></i>
            联系方式
          </h4>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="邮箱地址" prop="email">
                <el-input v-model="formData.email" placeholder="请输入邮箱地址"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机号码" prop="mobile">
                <el-input v-model="formData.mobile" placeholder="请输入手机号码"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="QQ号码" prop="qq">
                <el-input v-model="formData.qq" placeholder="请输入QQ号码"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="微信号" prop="wechat">
                <el-input v-model="formData.wechat" placeholder="请输入微信号"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="电话号码" prop="phone">
            <el-input v-model="formData.phone" placeholder="请输入电话号码"></el-input>
          </el-form-item>
        </div>

        <!-- 学校信息区域 -->
        <div class="form-section">
          <h4 class="section-title">
            <i class="el-icon-school"></i>
            学校信息
          </h4>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="所在学校" prop="school">
                <el-input v-model="formData.school" placeholder="请输入学校名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="所在年级" prop="grade">
                <el-input v-model="formData.grade" placeholder="请输入年级"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="所在班级" prop="class_name">
            <el-input v-model="formData.class_name" placeholder="请输入班级"></el-input>
          </el-form-item>
        </div>

        <!-- 账户信息区域（只读） -->
        <div class="form-section readonly-section">
          <h4 class="section-title">
            <i class="el-icon-info"></i>
            账户信息
          </h4>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="用户名">
                <el-input v-model="profile.username" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="用户状态">
                <el-input :value="statusText" readonly></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="注册时间">
                <el-input v-model="profile.createtime" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="上次登录">
                <el-input v-model="profile.prevtime" readonly></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="总登录次数">
                <el-input v-model="profile.login_count" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="连续登录天数">
                <el-input v-model="profile.successions" readonly></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSaveProfile" :loading="profileLoading">保存个人资料</el-button>
      <el-button type="warning" @click="handleChangePassword" :loading="passwordLoading">修改密码</el-button>
    </div>
  </el-dialog>
</template>

<script>
import ProfileAPI from "@/api/profile";
import { mapState } from "vuex";

export default {
  name: "UserProfileDialog",
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      profileLoading: false,
      passwordLoading: false,
      profile: {},
      formData: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
        real_name: "",
        email: "",
        mobile: "",
        qq: "",
        wechat: "",
        phone: "",
        gender: 0,
        birthday: "",
        age: null,
        bio: "",
        school: "",
        grade: "",
        class_name: ""
      },
      rules: {
        oldPassword: [
          { validator: this.validateOldPassword, trigger: "blur" }
        ],
        newPassword: [
          { validator: this.validateNewPassword, trigger: "blur" }
        ],
        confirmPassword: [
          { validator: this.validateConfirmPassword, trigger: "blur" }
        ],
        email: [
          { type: "email", message: "请输入正确的邮箱地址", trigger: "blur" }
        ],
        mobile: [
          { pattern: /^1[3-9]\d{9}$/, message: "请输入正确的手机号码", trigger: "blur" }
        ],
        age: [
          { type: "number", min: 1, max: 120, message: "年龄必须在 1 到 120 之间", trigger: "blur" }
        ]
      },
      uploadAction: process.env.VUE_APP_API_BASE_URL + "/profile/uploadAvatar",
      uploadHeaders: {}
    };
  },
  computed: {
    ...mapState("user", ["userInfo", "token"]),
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    },
    statusText() {
      const statusMap = {
        'normal': '正常',
        'hidden': '隐藏'
      };
      return statusMap[this.profile.status] || this.profile.status || '未知';
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.loadProfile();
        this.setUploadHeaders();
      }
    }
  },
  methods: {
    /**
     * 加载用户资料
     */
    async loadProfile() {
      try {
        this.loading = true;
        const response = await ProfileAPI.getUserProfile();
        
        if (response.success) {
          this.profile = response.data;
          this.formData = {
            oldPassword: "",
            newPassword: "",
            confirmPassword: "",
            real_name: this.profile.real_name || "",
            email: this.profile.email || "",
            mobile: this.profile.mobile || "",
            qq: this.profile.qq || "",
            wechat: this.profile.wechat || "",
            phone: this.profile.phone || "",
            gender: this.profile.gender || 0,
            birthday: this.profile.birthday || "",
            age: this.profile.age || null,
            bio: this.profile.bio || "",
            school: this.profile.school || "",
            grade: this.profile.grade || "",
            class_name: this.profile.class_name || ""
          };
        } else {
          this.$message.error(response.message || "加载用户资料失败");
        }
      } catch (error) {
        console.error("加载用户资料失败：", error);
        this.$message.error("加载用户资料失败");
      } finally {
        this.loading = false;
      }
    },

    /**
     * 设置上传请求头
     */
    setUploadHeaders() {
      if (this.token) {
        this.uploadHeaders = {
          Token: this.token,
          Username: this.userInfo.username
        };
      }
    },

    /**
     * 验证原密码
     */
    validateOldPassword(rule, value, callback) {
      // 如果新密码有值，则原密码必填
      if (this.formData.newPassword && !value) {
        callback(new Error("请输入原密码"));
      } else {
        callback();
      }
    },

    /**
     * 验证新密码
     */
    validateNewPassword(rule, value, callback) {
      // 如果原密码有值，则新密码必填
      if (this.formData.oldPassword && !value) {
        callback(new Error("请输入新密码"));
      } else if (value && (value.length < 6 || value.length > 30)) {
        callback(new Error("密码长度在 6 到 30 个字符"));
      } else {
        callback();
      }
    },

    /**
     * 验证确认密码
     */
    validateConfirmPassword(rule, value, callback) {
      // 如果新密码有值，则确认密码必填
      if (this.formData.newPassword && !value) {
        callback(new Error("请确认新密码"));
      } else if (value && value !== this.formData.newPassword) {
        callback(new Error("两次输入密码不一致"));
      } else {
        callback();
      }
    },

    /**
     * 头像上传前验证
     */
    beforeAvatarUpload(file) {
      const isImage = file.type.startsWith("image/");
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isImage) {
        this.$message.error("上传头像图片只能是图片格式!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
        return false;
      }
      return true;
    },

    /**
     * 头像上传成功
     */
    handleAvatarSuccess(response) {
      if (response.success) {
        this.profile.avatar = response.data.avatar;
        this.$message.success("头像上传成功");
      } else {
        this.$message.error(response.message || "头像上传失败");
      }
    },

    /**
     * 保存个人资料
     */
    async handleSaveProfile() {
      try {
        // 验证个人资料表单
        await this.$refs.profileForm.validate();
        
        this.profileLoading = true;
        
        const profileData = {
          real_name: this.formData.real_name,
          email: this.formData.email,
          mobile: this.formData.mobile,
          qq: this.formData.qq,
          wechat: this.formData.wechat,
          phone: this.formData.phone,
          gender: this.formData.gender,
          birthday: this.formData.birthday,
          age: this.formData.age,
          bio: this.formData.bio,
          school: this.formData.school,
          grade: this.formData.grade,
          class_name: this.formData.class_name
        };
        
        const profileResponse = await ProfileAPI.updateUserProfile(profileData);
        
        if (!profileResponse.success) {
          this.$message.error(profileResponse.message || "更新个人资料失败");
          return;
        }
        
        this.$message.success("个人资料更新成功");
        this.$emit("profile-updated");
      } catch (error) {
        console.error("保存个人资料失败：", error);
        this.$message.error("保存个人资料失败");
      } finally {
        this.profileLoading = false;
      }
    },

    /**
     * 修改密码
     */
    async handleChangePassword() {
      try {
        // 验证密码表单
        if (!this.formData.oldPassword) {
          this.$message.error("请输入原密码");
          return;
        }
        if (!this.formData.newPassword) {
          this.$message.error("请输入新密码");
          return;
        }
        if (this.formData.newPassword !== this.formData.confirmPassword) {
          this.$message.error("两次输入的新密码不一致");
          return;
        }
        
        this.passwordLoading = true;
        
        const passwordData = {
          oldPassword: this.formData.oldPassword,
          newPassword: this.formData.newPassword,
          confirmPassword: this.formData.confirmPassword
        };
        
        const passwordResponse = await ProfileAPI.changePassword(passwordData);
        
        if (!passwordResponse.success) {
          this.$message.error(passwordResponse.message || "修改密码失败");
          return;
        }
        
        this.$message.success("密码修改成功");
        
        // 清空密码字段
        this.formData.oldPassword = "";
        this.formData.newPassword = "";
        this.formData.confirmPassword = "";
      } catch (error) {
        console.error("修改密码失败：", error);
        this.$message.error("修改密码失败");
      } finally {
        this.passwordLoading = false;
      }
    },

    /**
     * 关闭对话框
     */
    handleClose() {
      this.dialogVisible = false;
      this.$refs.profileForm.resetFields();
    }
  }
};
</script>

<style scoped>
.profile-dialog {
  .profile-container {
    max-height: 70vh;
    overflow-y: auto;
  }

  .avatar-section {
    margin-bottom: 30px;
    padding: 20px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 10px;
    color: white;

    .avatar-container {
      display: flex;
      align-items: center;
      gap: 20px;

      .avatar-uploader {
        .avatar {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          object-fit: cover;
          border: 3px solid rgba(255, 255, 255, 0.3);
        }

        .avatar-uploader-icon {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          border: 2px dashed rgba(255, 255, 255, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          color: rgba(255, 255, 255, 0.7);
          background: rgba(255, 255, 255, 0.1);
          cursor: pointer;
          transition: all 0.3s;

          &:hover {
            border-color: rgba(255, 255, 255, 0.8);
            color: white;
            background: rgba(255, 255, 255, 0.2);
          }
        }
      }

      .avatar-info {
        h3 {
          margin: 0 0 5px 0;
          font-size: 24px;
          font-weight: 600;
        }

        p {
          margin: 0;
          opacity: 0.8;
          font-size: 14px;
        }
      }
    }
  }

  .form-section {
    margin-bottom: 30px;
    padding: 20px;
    border: 1px solid #e4e7ed;
    border-radius: 8px;
    background: #fafafa;

    .section-title {
      margin: 0 0 20px 0;
      padding-bottom: 10px;
      border-bottom: 2px solid #409eff;
      color: #303133;
      font-size: 16px;
      font-weight: 600;
      display: flex;
      align-items: center;
      gap: 8px;

      i {
        color: #409eff;
        font-size: 18px;
      }
    }

    &.readonly-section {
      background: #f5f7fa;
      border-color: #dcdfe6;

      .section-title {
        color: #909399;
        border-bottom-color: #dcdfe6;

        i {
          color: #909399;
        }
      }
    }
  }

  .profile-form {
    .el-form-item {
      margin-bottom: 20px;
    }

    .el-input,
    .el-select,
    .el-date-picker,
    .el-input-number {
      width: 100%;
    }

    .el-textarea {
      .el-textarea__inner {
        resize: vertical;
      }
    }
  }

  .dialog-footer {
    text-align: right;
    padding: 20px 0 0 0;
    border-top: 1px solid #e4e7ed;

    .el-button {
      min-width: 100px;
    }
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .profile-dialog {
    .el-dialog {
      width: 95% !important;
      margin: 0 auto;
    }

    .avatar-section .avatar-container {
      flex-direction: column;
      text-align: center;
      gap: 15px;
    }

    .form-section {
      padding: 15px;
    }
  }
}
</style>
